import { render, staticRenderFns } from "./miodata.vue?vue&type=template&id=46ccc4f8&scoped=true&"
import script from "./miodata.vue?vue&type=script&lang=ts&"
export * from "./miodata.vue?vue&type=script&lang=ts&"
import style0 from "./miodata.vue?vue&type=style&index=0&id=46ccc4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccc4f8",
  null
  
)

export default component.exports